import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bonusomat-raffle-counters__counter-box bonusomat-raffle-counters__counter-box--failed"
}
const _hoisted_2 = {
  key: 0,
  class: "bonusomat-raffle-counters__counters-group bonusomat-raffle-counters__counters-group--default"
}
const _hoisted_3 = { class: "bonusomat-raffle-counters__counter-box bonusomat-raffle-counters__counter-box--draw-counter" }
const _hoisted_4 = {
  key: 0,
  class: "bonusomat-raffle-counters__counter-box bonusomat-raffle-counters__counter-box--ticket-counter"
}
const _hoisted_5 = {
  key: 1,
  class: "bonusomat-raffle-counters__counters-group bonusomat-raffle-counters__counters-group--allwyn"
}
const _hoisted_6 = { class: "bonusomat-raffle-counters__counter-box bonusomat-raffle-counters__counter-box--draw-counter" }
const _hoisted_7 = {
  key: 0,
  class: "bonusomat-raffle-counters__counter-box bonusomat-raffle-counters__counter-box--ticket-counter"
}

import AllwynHeadingBox from "../raffle/allwyn-heading-box.vue";
import TimeCounter from "../raffle/time-counter.vue";
import BonusomatCounter from "../shared/bonusomat-counter.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'bonusomat-raffle-counters-group',
  props: {
    hasRaffleDataLoadingFailed: { type: Boolean },
    showDefaultCounters: { type: Boolean },
    totalWin: {},
    raffleRemainingSeconds: {},
    showAllwynCounters: { type: Boolean },
    allwynName: {},
    allwynRemainingSeconds: {},
    showTicketsCounters: { type: Boolean },
    raffleTicketsCount: {},
    allwynTicketsCount: {},
    isWidget: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_ctx.hasRaffleDataLoadingFailed)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
        _createElementVNode("div", { class: "bonusomat-placeholder" }, [
          _createElementVNode("div", { class: "bonusomat-placeholder__text" }, "Při načítání losovačky nastala chyba"),
          _createElementVNode("div", { class: "bonusomat-placeholder__subtext" }, "Zkuste to prosím později")
        ], -1)
      ])))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        (_ctx.showDefaultCounters)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", {
                class: _normalizeClass(["bonusomat-raffle-counters__counter-box bonusomat-raffle-counters__counter-box--main", { 'bonusomat-raffle-counters__counter-box--highlighted': !_ctx.isWidget }])
              }, [
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "bonusomat-raffle-counters__counter-box__title" }, "Aktuálně hrajeme o celkem", -1)),
                _createVNode(BonusomatCounter, {
                  counterValue: _ctx.totalWin ?? 0,
                  "numeral-count": 6,
                  unit: "Kč",
                  "is-widget": _ctx.isWidget
                }, null, 8, ["counterValue", "is-widget"])
              ], 2),
              _createElementVNode("div", _hoisted_3, [
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "bonusomat-raffle-counters__counter-box__title" }, "Slosování za", -1)),
                _createVNode(TimeCounter, { remainingSeconds: _ctx.raffleRemainingSeconds }, null, 8, ["remainingSeconds"])
              ]),
              (_ctx.showTicketsCounters)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "bonusomat-raffle-counters__counter-box__title" }, "Vaše tikety", -1)),
                    _createVNode(BonusomatCounter, {
                      counterValue: _ctx.raffleTicketsCount ?? 0,
                      "numeral-count": 2
                    }, null, 8, ["counterValue"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.showAllwynCounters)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(AllwynHeadingBox, { name: _ctx.allwynName }, null, 8, ["name"]),
              _createElementVNode("div", _hoisted_6, [
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "bonusomat-raffle-counters__counter-box__title" }, "Slosování za", -1)),
                _createVNode(TimeCounter, { remainingSeconds: _ctx.allwynRemainingSeconds }, null, 8, ["remainingSeconds"])
              ]),
              (_ctx.showTicketsCounters)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "bonusomat-raffle-counters__counter-box__title" }, "Vaše tikety", -1)),
                    _createVNode(BonusomatCounter, {
                      counterValue: _ctx.allwynTicketsCount ?? 0,
                      "numeral-count": 2
                    }, null, 8, ["counterValue"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ], 64))
}
}

})